//
// Url util
// -------------

define(function(require, exports, module) {
    'use strict';
    var _ = require('underscore');
    var langUtil = require('util/language.util');

    module.exports = {

        _language: null,

        // ? it was made to fix circular refs
        setLocale: function(lang) {
            this._language = lang;
        },

        // -
        get pathname() {
            return window.history.pushState ? window.location.pathname : this.hash.replace(/#/gi, '/');
        },

        // -
        get search() {
            return window.location.search;
        },

        // -
        get origin() {
            return window.location.origin;
        },

        // -
        get href() {
            return window.location.href;
        },

        // -
        get hash() {
            return window.location.hash;
        },

        // +? as `getBaseDomain()`
        get baseDomain() {
            var domain = document.domain.split('.');

            // check for IP
            if (/^\d+(\.\d+)*$/.test(document.domain)) {
                return document.domain;
            }

            if (domain.length > 2) {
                return '.' + domain.splice(-2).join('.');
            }

            return document.domain;
        },

        // +? as `getFriendlyUrl()`
        get friendlyUrl() {
            return this.getFriendlyUrl(this.pathname);
        },

        // +
        _parseUrl: function(path) {
            var url = _.compact(path && path.split('/'));
            // Lang always at the head of path
            var lang = langUtil.getLanguage(url[0]);
            if (lang) {
                // remove language from url if it's actually a language
                url.shift();
            }
            var friendlyUrl = url.join('/');
            var cleanUrl = '/' + friendlyUrl;

            return {
                lang: lang,
                friendlyUrl: friendlyUrl,
                cleanUrl: cleanUrl
            };
        },

        // +
        /**
         * Get url without language
         * @param {string} path
         * @return {string}
         */
        getCleanUrl: function(path) {
            return this._parseUrl(path).cleanUrl;
        },

        // +
        /**
         * Get clean url without leading slash
         * @param  {string} path
         * @return {string}
         */
        getFriendlyUrl: function(path) {
            return this._parseUrl(path).friendlyUrl;
        },

        // - use `new URL(location).pathname`
        /**
         * Return pathname for url, works loke location.pathname
         * @param  {string} url
         * @return {string}
         */
        getPathname: function(url) {
            return url
                .split('?')[0] // remove query parameters
                .replace(/^.*\/\/[^\/]+/, '') // get pathname
                .replace(/^\/?/, '/'); // add slash to the beginning
        },

        // - use `new URL(location).search`
        /**
         * Return query string for url, works like location.search
         * @param  {string} url
         * @return {string}
         */
        getSearch: function(url) {
            var queryParams = url.split('?').splice(1).join('?');

            return queryParams ? '?' + queryParams : '';
        },

        /**
         * Get url with user language
         * @param  {string} path
         * @param  {string} [lang]
         * @return {string}
         */
        getUrlWithLanguage: function(path, lang) {
            lang = langUtil.getAliasForLanguage(lang || langUtil.getLanguage(this._language));
            path = this.getCleanUrl(path);

            return lang && lang !== langUtil.defaultLocale ? (langUtil.getShortLanguage(lang) || lang) + path : path;
        },

        // +? as `getLang`
        /**
         * Get lang from url
         * @param  {string} path
         * @return {string}
         */
        parseLang: function(path) {
            var lang = this._parseUrl(path).lang;
            lang = langUtil.getLanguage(lang);
            return langUtil.getLanguageForAlias(lang) || lang;
        },

        // +
        /**
         * Returns object of key/value from query string
         * @param  {string} [str=this.search] - location search string
         * @return {Object} Object of key/value from query string
         */
        getURLParams: function(str) {
            var ret = {};

            if (typeof str === 'undefined') {
                // use current location search
                str = this.search;
            } else {
                str = this.getSearch(str) || str;
            }

            if (typeof str !== 'string') {
                return ret;
            }

            str = str.trim().replace(/^([?#&])/, '');

            if (!str) {
                return ret;
            }

            _.compact(str.split('&')).forEach(function(param) {
                var parts = param.replace(/\+/g, ' ').split('=');
                // Firefox (pre 40) decodes `%3D` to `=`
                // https://github.com/sindresorhus/query-string/pull/37
                var key = parts.shift();
                // missing `=` should be `null`:
                // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
                var val = parts.length > 0 ? this.safeDecodeURIComponent(parts.join('=')) : null;

                key = this.safeDecodeURIComponent(key);

                if (!key) {
                    //skip invalid keys
                    return;
                }

                if (ret[key] === undefined) {
                    ret[key] = val;
                } else if (Array.isArray(ret[key])) {
                    ret[key].push(val);
                } else {
                    ret[key] = [ret[key], val];
                }
            }.bind(this));

            return ret;
        },

        /**
         * Returns value of current search parameter
         * @param  {string} name
         * @return {string}
         */
        getLocationParameterByName: function(name) {
            name = name.replace(/\[/, '\\[').replace(/]/, '\\]');

            var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
            var results = regex.exec(this.search);

            return results ? this.safeDecodeURIComponent(results[1].replace(/\+/g, ' ')) : null;
        },

        /**
         * Get new URL with adding new params. If name of adding param is the same - replace by new value
         * @param  {Object} newParams  Object of key/value for add to URL
         * @return {string} string with new URL
         */
        getParametrizedURL: function(newParams) {
            var pathname = this.pathname;
            var currentParams = this.getURLParams();
            var url = '?' + this.serialize(_.extend(currentParams, newParams));

            return pathname + url;
        },

        /**
         * Serialize object to search string
         * @param {Object|Array} obj
         * @param {boolean} [encode=true]
         * @return {string}
         */
        serialize: function(obj, encode) {
            if (encode == null) {
                encode = true;
            }

            //https://www.w3.org/TR/2012/WD-url-20120524/#url-parameter-serialization
            var serializeParam = function(isEncode, key) {
                var k = isEncode ? encodeURIComponent(key) : key;
                var v = isEncode ? encodeURIComponent(obj[key]) : obj[key];
                //check on `null`, `undefined`, `NaN`
                if (obj[key] == null || obj[key] !== obj[key]) { // eslint-disable-line
                    return k;
                }
                return k + '=' + v;
            };

            return Object.keys(obj)
                .map(serializeParam.bind(null, encode))
                .join('&');
        },

        /**
         * Check is url for external page
         * @param  {string}  url
         * @return {boolean}
         */
        isExternalUrl: function(url) {
            var match = url.match(/^([^:\/?#]+:)?(?:\/\/([^\/?#]*))?([^?#]+)?(\?[^#]*)?(#.*)?/);
            if (typeof match[1] === 'string' && match[1].length > 0 && match[1].toLowerCase() !== location.protocol) {
                return true;
            }
            if (typeof match[2] === 'string' && match[2].length > 0
                && match[2].replace(
                    new RegExp(':(' + {'http:': 80, 'https:': 443}[location.protocol] + ')?$'), ''
                ) !== location.host) {
                return true;
            }

            return false;
        },

        /**
         * Simple redirect, use `core.navigate` as abstraction
         * @param  {string} url
         */
        redirect: function(url) {
            window.location.href = url;
        },

        /**
         * Simple redirect, use `core.navigate` as abstraction
         */
        reload: function() {
            window.location.reload();
        },

        /**
         * Wrapper for window.open(). Preferred over native call. Carries same signature as native.
         * @param {string} [url]
         * @param {string} [name]
         * @param {string} [features]
         * @returns {Window}
         */
        openWindow: function(url, name, features) {
            if (name == null) {
                name = ''; // override native forced String() conversion of null values
            }

            return window.open(url, name, features || '');
        },

        /**
         * Wrapper for window.open() that open new window by default.
         * @param {string} [url]
         * @param {string} [name]
         * @param {string} [features]
         * @returns {*}
         */
        openNewWindow: function(url, name, features) {
            features = features || 'resizable=yes, width=800px, height=600px';

            return this.openWindow(url, name, features);
        },

        /**
         * Parse URL template, getting get & post params
         * @param {string} str
         * @param {Object} [replacements] - hash with keys as template parameter names and their values
         * @returns {{url: *, getParams: *, postParams: *}}
         */
        parseTemplateURL: function(str, replacements) {
            var url = str.split('?')[0];
            var hashSplit = str.split('#');
            var hash = hashSplit[1] ? `#${hashSplit[1]}` : '';
            var params = hashSplit[0].replace(url + '?', '').split('|');
            var getParams = params[0].length ? params[0] : '';
            var postParams = params.length > 1 ? params[1] : '';
            var tmplParam;

            var filterParams = function(serializedParams) {
                var filteredParams = {};

                _.each(this.getURLParams(serializedParams), function(val, key) {
                    // skip empty params from IMS
                    if (val && val.indexOf('[') === -1) {
                        filteredParams[key] = val;
                    } else if ((tmplParam = val?.replace(/[\[\]]/g, '')) && replacements[tmplParam]) {
                        filteredParams[key] = replacements[tmplParam];
                    }
                });

                return filteredParams;
            }.bind(this);

            replacements = replacements || {};

            return {
                url: url,
                hash,
                getParams: filterParams(getParams),
                postParams: filterParams(postParams)
            };
        },

        /**
         * Tries to decode a string as URI component without throwing a malformed URI exception
         * @param uri
         * @returns {string|null}
         */
        safeDecodeURIComponent: function(uri) {
            try {
                return decodeURIComponent(uri);
            } catch (e) {
                return null;
            }
        },

        /**
         * Check if URL matches Data URIs syntax:
         * https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
         * @param uri
         * @returns {boolean}
         */
        isDataURI: function(uri) {
            return /^\s*data:/i.test(uri);
        },

        /**
         * Check if URL contains javascript:
         * @param uri
         * @returns {boolean}
         */
        isJavascriptURI(uri) {
            return /^\s*javascript:/i.test(uri);
        },

        /**
         * Check if open game page
         * @returns {boolean}
         */
        isLaunchGamePath: function() {
            var regExp = /igaming\//g;

            return regExp.test(this.pathname);
        }
    };
});
